import script from "./ModelCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelCard.vue?vue&type=script&setup=true&lang=js"

import "./ModelCard.vue?vue&type=style&index=0&id=31201c92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31201c92"]])

export default __exports__